import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalTitle from "react-bootstrap/ModalTitle";
import ModalBody from "react-bootstrap/ModalBody";
import ModalFooter from "react-bootstrap/ModalFooter";
import API from "../../../src/apiService";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Table from "../component/Table";
import printJS from 'print-js';
import apiService from 'apiService';
import { showLoading, toast } from "view/component/Alert";

export default class ModalRujukanInternal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ref_clinics: [],
      param: {
        nik: this.props.patient.patients.nik,
        name: this.props.patient.patients.name,
        last_name: this.props.patient.patients.last_name,
        sex: this.props.patient.patients.sex,
        parent_name: this.props.patient.patients.parent_name,
        birth_place: this.props.patient.patients.birth_place,
        birth_date: this.props.patient.patients.birth_date,
        address: this.props.patient.patients.address,
        village_id: this.props.patient.patients.village_id,
        education_id: this.props.patient.patients.education_id,
        job_id: this.props.patient.patients.job_id,
        religion_id: this.props.patient.patients.religion_id,
        marital_status_id: this.props.patient.patients.marital_status_id,
        contact: this.props.patient.patients.contact,
        photo: this.props.patient.patients.photo,
        flag: this.props.patient.patients.flag,
        rekam_medis_flags: this.props.patient.patients.rekam_medis_flags,
        parent_id: this.props.patient.parent_id,
        patient_id: this.props.patient.patient_id,
        family_folder: this.props.patient.family_folder,
        family_relationship_id: this.props.patient.family_relationship_id,
        paramedic_id: null,
        // user_id_poli: this.props.patient.user_id_poli,
        payment_type_id: this.props.patient.payment_type_id,
        clinic_id: "",
        insurance_no: this.props.patient.insurance_no,
        resume: this.props.patient.resume,
        previous_clinic_id: this.props.patient.clinic_id,
        continue_id: this.props.patient.continue_id,
        continue_to: this.props.patient.continue_to,
        continue_internal: null,
        served: false,
        pcare_patient_code_provider: this.props.patient
          .pcare_patient_code_provider,
        admission_type_id: this.props.patient.admission_type_id,
        drug_taken: this.props.patient.drug_taken,
        specialis: this.props.patient.specialis,
        visit_type: this.props.patient.visit_type,
        served_card: this.props.patient.served_card,
        clinic_group: this.props.patient.clinic_group,
        nurse_id: null,
        kd_sadar: this.props.patient.kd_sadar,
        kd_tacc: this.props.patient.kd_tacc,
        pcare_visit_number: null,
        pcare_queue_number: null,
        pcare_treatment_code: 10,
        pcare_sick:1,
        queue: null,
        statuscall: "0",
        statustracer: "0",
        flg_outdoor: null,
        outdoor_visit_id: null,
        ambulance: "0",
        flg_resume: null,
        drug_queue: null,
        bloodId: this.props.patient.examinations[0].blood_type_id,
      },
      selectedClinic: [],
      puskesmas_id: JSON.parse(localStorage.getItem("puskesmasProfile"))
        ? JSON.parse(localStorage.getItem("puskesmasProfile")).code
        : "",
    };
    this.onchangeClinic = this.onchangeClinic.bind(this);
    this.PostData = this.PostData.bind(this);
    this.requestFile = this.requestFile.bind(this)
  }
  componentDidMount() {
    this.getClinics();
  }

  getClinics = async (e) => {
    const res = await API.get(
      "/apm/clinics/read/" + this.state.puskesmas_id + "/2/0"
    );

    if (res.code === 200) {
      let clinics = res.data;
      // let filterClinic = clinics.filter(element => element.type > 1);
      console.log(clinics);
      this.setState({
        ref_clinics: clinics,
      });
    }
  };

  onchangeClinic(e) {
    console.log(this.props);
    let selectedClinic = this.state.selectedClinic;
    let par = this.state.param;
    let value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    if (value) {
      let param = {
        address: par.address,
        admission_type_id: par.admission_type_id,
        ambulance: par.ambulance,
        birth_date: par.birth_date,
        birth_place: par.birth_place,
        bloodId: par.bloodId,
        clinic_group: par.clinic_group,
        clinic_id: e.target.value,
        contact: par.contact,
        continue_id: par.continue_id,
        continue_internal: par.continue_internal,
        continue_to: par.continue_to,
        drug_queue: par.drug_queue,
        drug_taken: par.drug_taken,
        education_id: par.education_id,
        family_folder: par.family_folder,
        family_relationship_id: par.family_relationship_id,
        flag: par.flag,
        flg_outdoor: par.flg_outdoor,
        flg_resume: par.flg_resume,
        insurance_no: par.insurance_no,
        job_id: par.job_id,
        kd_sadar: par.kd_sadar,
        kd_tacc: par.kd_tacc,
        last_name: par.last_name,
        marital_status_id: par.marital_status_id,
        name: par.name,
        nik: par.nik,
        nurse_id: par.nurse_id,
        outdoor_visit_id: par.outdoor_visit_id,
        paredic_id: par.paredic_id,
        parent_id: par.parent_id,
        parent_name: par.parent_name,
        patient_id: par.patient_id,
        payment_type_id: par.payment_type_id,
        pcare_patient_code_provider: par.pcare_patient_code_provider,
        pcare_queue_number: par.pcare_queue_number,
        pcare_visit_number: par.pcare_visit_number,
        photo: par.photo,
        previous_clinic_id: this.props.patient.clinic_id,
        queue: par.queue,
        rekam_medis_flags: par.rekam_medis_flags,
        religion_id: par.religion_id,
        resume: par.resume,
        served: par.served,
        served_card: par.served_card,
        sex: par.sex,
        specialis: par.specialis,
        statuscall: par.statuscall,
        statustracer: par.statustracer,
        village_id: par.village_id,
        visit_type: par.visit_type,
        pcare_treatment_code: 10,
        pcare_sick:1,
      };
      selectedClinic.push(param);
    } else {
      selectedClinic = selectedClinic.filter(
        (el) => parseInt(el.clinic_id) !== parseInt(e.target.value)
      );
    }
    this.setState({ selectedClinic });
  }

  PostData = async () => {
    let visit_id = [];
    // this.state.selectedClinic.map((param, key) => {
    //   let res = await API.post(`registration/visit`, param);

    //   if (res.code === 200) {
    //     // this.requestFile(`/apm/queues/print?visit_id=${res.data.visit.id}`)
    //     visit_id.push(res.data.visit.id)
    //     console.log(res.data, visit_id)
    //   }
    // });
    showLoading('menyimpan data')
    for (let index = 0; index < this.state.selectedClinic.length; index++) {
      let res = await API.post(`registration/rujuk_internal`, this.state.selectedClinic[index]);
      if (res.code === 200) {
        // this.requestFile(`/apm/queues/print?visit_id=${res.data.visit.id}`)
        visit_id.push(res.data.visit.id)
        // const bridgingResult = await API.post(
        //   `/pcare/pendaftaran/${res.data.visit.id}`
        // );
      }
    }
    toast({status:'success', text:'selesai'})
    this.requestFile(`/apm/queues/print?visit_id=${visit_id.toString()}&is_lab=false`)
    this.props.onHide();
    this.props.handleSubmit();
  };

  requestFile = async (url) => {
    const res = await API.getblob(url);
    if (res) {
      const file = new Blob([res], { type: 'application/pdf' });
      //Build a URL from the file
      const fileURL = URL.createObjectURL(file);
      //print blob
      printJS(fileURL);
    }
  };

  render() {
    console.log(this.state);
    let clinics = this.state.ref_clinics.map((data, key) => {
      if (data.clinic.child.length > 0) {
        return (
          <div className="col-md-12 row" key={key}>
            {data.clinic.child.map((d, ky) => {
              return (
                <div className="col-md-6" key={ky}>
                  {d.name}

                  <label
                    style={{ float: "right" }}
                    className="badge badge-primary badge-pill"
                  >
                    <input
                      className="custom-checkbox"
                      name={"clinic_" + d.clinic_id}
                      type="checkbox"
                      // checked={lab.checked}
                      // disabled={lab.disabled}
                      value={d.clinic_id}
                      onChange={this.onchangeClinic}
                    />{" "}
                  </label>
                </div>
              );
            })}
          </div>
        );
      } else {
        return (
          <div className="col-md-6" key={key}>
            {data.clinic.name}

            <label
              style={{ float: "right" }}
              className="badge badge-primary badge-pill"
            >
              <input
                className="custom-checkbox"
                name={"clinic_" + data.clinic.id}
                type="checkbox"
                // checked={lab.checked}
                // disabled={lab.disabled}
                value={data.clinic.id}
                onChange={this.onchangeClinic}
              />{" "}
            </label>
          </div>
        );
      }
    });
    return (
      <div>
        <Modal {...this.props} size="lg" aria-labelledby="modal-rujukan">
          <ModalHeader closeButton>
            <ModalTitle id="modal-rujukan">RUJUKAN INTERNAL</ModalTitle>
          </ModalHeader>
          <ModalBody>
            <div className="col-md-12 row">{clinics}</div>
          </ModalBody>
          <ModalFooter>
            <div className="row">
              <button
                type="button"
                onClick={this.props.onHide}
                className="btn btn-danger"
              >
                tutup
              </button>
              <button
                type="button"
                className="btn btn-success"
                onClick={this.PostData}
              >
                selesai
              </button>
            </div>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
